export * from './o2-tour.service';
export * from './o2-tour.module';



// WEBPACK FOOTER //
// ./src/app/o2-tour/index.ts